import React from 'react'

import TelaDinamicaFormPageContainer from './TelaDinamicaFormPageContainer'

export class TelaDinamicaFormPage extends React.Component {
  render() {
    return <TelaDinamicaFormPageContainer {...this.props} />
  }
}
